module.exports = "<div style=\"padding: 0 15px\"> <group title=正常类></group> <tag>新春特惠</tag> <tag type=green>新春特惠</tag> <tag type=gray>新春特惠</tag> <tag type=purple>新春特惠</tag> <group title=line类></group> <tag line>新春特惠</tag> <tag type=green line>新春特惠</tag> <tag type=gray line>新春特惠</tag> <tag type=purple line>新春特惠</tag> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Tag.vue
 ** module id = 202
 ** module chunks = 0
 **/